import React, { useState, useEffect, useRef } from "react";
import AdminAnalyticsComponent from "./admin-components/adminanalyticsComponent";
import AdminUserAdministrationComponent from "./admin-components/adminuserAdminstationComponent";
import CompanySettingsPanel from "./admin-components/CompanySettingsPanel"
const AdminUser = () => {
  return (
    <div className="dashboard">
        <AdminAnalyticsComponent />
        <AdminUserAdministrationComponent />
        <CompanySettingsPanel/>
    </div>
  )
};


export default AdminUser;